import { makeStyles, Grid, Typography } from "@material-ui/core";

import { DialogBox } from "../../components/boxes";
import {
  Dialog,
  TextInput,
  Icon,
  TextButton,
  Button,
  DropdownInput
} from "../../components/base";
import CloseIcon from "../../assets/images/modals/CloseModal.svg";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 520,
    height: 360
  },
  closeicon: {
    marginTop: 10
  },
  heading: {
    fontWeight: 700,
    color: COLORS.darks[0][100],
    fontSize: 24
  },
  groupBtn: {
    marginTop: theme.spacing(6)
  },
  iconWrapper: {
    height: "25px"
  },
  labelstyle: {
    color: "rgba(0, 0, 0, 0.6)"
  }
}));

export const AddUserModal = ({
  isOpen,
  setOpen,
  loader,
  addUserDetails,
  handleUserDetails,
  handleAddUser,
  errors
}) => {
  const classes = useStyles();

  return (
    <Dialog isOpen={isOpen} onClose={() => setOpen(false)}>
      <DialogBox>
        <Grid
          className={classes.closeicon}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className={classes.heading}>Add User</Typography>
          <Icon
            root={classes.iconWrapper}
            src={CloseIcon}
            hoverable
            tooltip="Close"
            onClick={() => setOpen(false)}
          />
        </Grid>
        <Grid
          xs={8}
          container
          justifyContent="center"
          className={classes.root}
          direction="column"
        >
          <TextInput
            id="companyname-input"
            fullWidth
            placeHolder="full name comes here"
            label="Name"
            value={addUserDetails.name}
            onChange={(e) => handleUserDetails(e, "name")}
            error={errors?.userName}
            labelRoot={classes.labelstyle}
          />
          <TextInput
            id="email-input"
            fullWidth
            label="Email"
            name="email"
            value={addUserDetails.email}
            onChange={(e) => handleUserDetails(e, "email")}
            error={errors?.email}
            labelRoot={classes.labelstyle}
          />
          <DropdownInput
            options={["Executive", "Operator", "Basic", "Admin"]}
            label="Role"
            style={{ marginTop: "10px", width: "100%" }}
            setvalue={(e) => handleUserDetails(e, "role")}
            value={addUserDetails.role}
            name="role"
            labelRoot={classes.labelstyle}
          />
          <Grid className={classes.groupBtn} container alignItems="center">
            <Button
              id="login-button"
              text="ADD"
              onClick={handleAddUser}
              loading={loader}
            />
            <TextButton
              text="CANCEL"
              normalFontWeight
              style={{ marginLeft: "30px" }}
              onClick={() => setOpen(false)}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </Dialog>
  );
};
